module.exports = __webpack_public_path__ + "img/transformacao-digital-cover.99a09a74.jpg";